import { createSlice, type PayloadAction } from '@reduxjs/toolkit/react';

type ApplicationState = {
    activeMenuItem: string[];
    drawerOpen: boolean;
    loading: string[];
};

export const applicationSlice = createSlice({
    name: 'application',
    initialState: {
        activeMenuItem: [],
        drawerOpen: true,
        loading: [],
    } as ApplicationState,
    reducers: {
        endApiRequest: (state, { payload }: PayloadAction<string>) => {
            state.loading = state.loading.filter(l => l !== payload);
        },
        setActiveMenuItem: (state, { payload }: PayloadAction<string[]>) => {
            state.activeMenuItem = [...payload];
        },
        setDrawerOpen: (state, { payload }: PayloadAction<boolean>) => {
            state.drawerOpen = payload;
        },
        startApiRequest: (state, { payload }: PayloadAction<string>) => {
            state.loading = [
                ...state.loading,
                payload,
            ];
        },
    },
    selectors: {
        selectActiveMenuItem: state => state.activeMenuItem,
        selectIsDrawerOpen: state => state.drawerOpen,
        selectIsLoading: state => state.loading.length > 0,
    },
});

export const {
    endApiRequest,
    setActiveMenuItem,
    setDrawerOpen,
    startApiRequest,
} = applicationSlice.actions;

export const {
    selectIsDrawerOpen,
    selectIsLoading,
} = applicationSlice.selectors;
